import { isFlagEnabled } from "js/utilities";
import { useTranslation } from "react-i18next";

export const useUnauthCustomerFaqs = () => {
  const { t } = useTranslation();
  return [
    {
      title: t("CustomerFaq-title-1"),
      desc: isFlagEnabled("ENABLE_SERVICE_TRACKING")
        ? t("CustomerFaq-desc-unAuthrelease")
        : t("CustomerFaq-desc-18"),
    },
    {
      title: t("CustomerFaq-title-4"),
      desc: t("CustomerFaq-desc-20"),
    },
    {
      title: t("CustomerFaq-title-13"),
      desc: t("CustomerFaq-desc-22"),
    },
    {
      title: t("CustomerFaq-title-14"),
      desc: isFlagEnabled("ENABLE_VA_PHONE_NUMBER_IN_FAQ")
        ? t("CustomerFaq-desc-23")
        : t("CustomerFaq-desc-24"),
    },
    {
      title: t("CustomerFaq-title-6"),
      desc: isFlagEnabled("ENABLE_VA_PHONE_NUMBER_IN_FAQ")
        ? t("CustomerFaq-desc-25")
        : t("CustomerFaq-desc-26"),
    },
    {
      title: t("CustomerFaq-title-15"),
      desc: t("CustomerFaq-desc-27"),
    },
    {
      title: t("CustomerFaq-title-8"),
      desc: isFlagEnabled("ENABLE_VA_PHONE_NUMBER_IN_FAQ")
        ? t("CustomerFaq-desc-28")
        : t("CustomerFaq-desc-29"),
    },
    {
      title: t("CustomerFaq-title-9"),
      desc: isFlagEnabled("ENABLE_VA_PHONE_NUMBER_IN_FAQ")
        ? t("CustomerFaq-desc-30")
        : t("CustomerFaq-desc-31"),
    },
    {
      title: t("CustomerFaq-title-10"),
      desc: t("CustomerFaq-desc-32"),
    },
  ];
};
